var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHomeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8l8-4.5L18 8h1.5l-1-1.5L16 5.03V2.5l-1-1-1 1v1.353L10 1.5l-8.5 5L.5 8H2zm1 1.5l7-4 7 4v9h-4v-7H7v7H3v-9z",
    fill: "#9A9CAC"
  })));
}

export default SvgHomeIcon;